import Button from 'components/Button/Button';
import {
  CompanyLogoWrapper,
  CompanyNameLabel,
  Container,
  imageStyle,
  CustomerNumber,
  IconWrapper,
} from './CompanyCard.styled';
import { useTranslation } from 'react-i18next';
import { ICompany } from 'types/Company.types';
import {
  AdaptiveImage,
  AdaptiveImageType,
} from 'components/AdaptiveImage/AdaptiveImage';
import { IRootReducerState } from 'store/store';
import { useSelector } from 'react-redux';
import Icon from 'components/Icon/Icon';
import { Trash } from '@phosphor-icons/react';
import { COLORS } from 'assets/styled';

interface ICompanyCardProps {
  company: ICompany;
  isSelected?: boolean;
  onSelect?: (company: ICompany) => void;
  onDelete?: (companyId: number) => void;
  onClick?: (company: ICompany) => void;
  notSelectable?: boolean;
}

const CompanyCard = ({
  company,
  isSelected,
  onSelect,
  onDelete,
  onClick,
  notSelectable = false,
}: ICompanyCardProps) => {
  const { t } = useTranslation();

  const { darkMode } = useSelector(
    (state: IRootReducerState) => state.commonInfo
  );

  const handleSelect = () => {
    onSelect?.(company);
  };

  const handleClick = () => {
    onClick?.(company);
  };

  return (
    <Container
      isSelected={isSelected}
      isDarkMode={darkMode}
      isClickable={!!onClick}
      onClick={handleClick}
    >
      {onDelete && (
        <IconWrapper>
          <Icon
            onClick={(e: any) => {
              e.stopPropagation();
              company && onDelete?.(Number(company.id));
            }}
            svg={Trash}
            weight="regular"
            color={COLORS.RED_100}
          />
        </IconWrapper>
      )}
      <CompanyLogoWrapper>
        <AdaptiveImage
          imageUrl={company.logo_url}
          type={AdaptiveImageType.COMPANY}
          imageStyle={imageStyle}
        />
      </CompanyLogoWrapper>
      <CompanyNameLabel>{company.name || 'Unnamed company'}</CompanyNameLabel>
      <CustomerNumber>{company.customer_number}</CustomerNumber>
      {onSelect && (
        <Button
          primary
          label={isSelected ? t('Deselect') : t('Select')}
          width="100%"
          height="25rem"
          wrapperStyle={{ width: '100%' }}
          onClick={handleSelect}
        />
      )}
      {notSelectable && (
        <Button
          primary
          label={t('Configure')}
          width="100%"
          height="25rem"
          wrapperStyle={{ width: '100%' }}
          onClick={handleClick}
        />
      )}
    </Container>
  );
};

export default CompanyCard;
